module.exports = __webpack_public_path__ + "img/Auto.7a7b8bc6.svg";